import {Component, computed, inject, input, output} from '@angular/core';
import {DirectusTranslatedItem} from '@frontend/directus';
import {TranslateDirectusPipe} from '@frontend/transloco';
import {TranslocoPipe} from '@jsverse/transloco';
import {Tag} from 'primeng/tag';
import {DirectusTooltipComponent} from '../../../../directus-tooltip/directus-tooltip.component';
import {SelectedLabel} from './multi-selection-label.types';

@Component({
  selector: 'app-multi-selection-label',
  imports: [TranslocoPipe, Tag, DirectusTooltipComponent],
  templateUrl: './multi-selection-label.component.html',
  providers: [TranslateDirectusPipe],
})
export class MultiSelectionLabelComponent {
  private readonly translateDirectusPipe = inject(TranslateDirectusPipe);

  noSelectKey = input.required<string>();
  options = input.required<DirectusTranslatedItem[]>();
  selectedIds = input.required<Array<string | number>>();
  isReadOnly = input<boolean>(true);

  remove = output<string | number>();

  protected selectedLabels = computed<SelectedLabel[]>(() => {
    const opts = this.options();
    return this.selectedIds()
      .map((id) => opts.find((opt) => opt.id === id))
      .filter((option): option is DirectusTranslatedItem => !!option)
      .map((option) => ({
        id: option.id,
        label: this.translateDirectusPipe.transform(option.translations) ?? '',
        tooltipKey: option.tooltip?.key,
        flagClass: `fi fi-${String(option.id).toLowerCase()}`,
      }));
  });
}
